import { ReactNode, useState } from "react";
import { GlobalContext } from "./GlobalContext";
import React from "react";

const ENABLE_ORDER_SOUND_KEY = "enableOrderSound";

export const GlobalContextProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [enableOrderSound, setEnableOrderSoundState] = useState<boolean>(() => {
    const saved = localStorage.getItem(ENABLE_ORDER_SOUND_KEY);
    if (saved !== null) {
      return saved === "true";
    }
    return true;
  });

  const setEnableOrderSound = (value: boolean) => {
    setEnableOrderSoundState(value);
    localStorage.setItem(ENABLE_ORDER_SOUND_KEY, value.toString());
  };

  return (
    <GlobalContext.Provider
      value={{
        enableOrderSound,
        setEnableOrderSound,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
